import { Icon, IconName } from "@nju/icons";
import { Text } from "@nju/ui";
import { formatPhoneNumber, POSITIVE_DIGITS } from "@nju/utils";

interface ITitleProps {
  title: string;
  iconName: IconName;
  clientNumber?: string;
  testId?: string;
}

export function Title({ title, iconName, clientNumber, testId }: ITitleProps) {
  return (
    <div className="flex items-center gap-3">
      <Icon
        className="w-5 h-5 from-tablet:w-6 from-tablet:h-6"
        name={iconName}
        tone="accent"
      />
      <div className="flex flex-col">
        <Text
          size={{
            "@onlyMobile": "m",
            "@fromTablet": "xl",
          }}
          weight="bold"
        >
          {title}
        </Text>
        <div data-cy={testId}>
          {clientNumber &&
            formatPhoneNumber(clientNumber, POSITIVE_DIGITS, " ", "+48", true)}
        </div>
      </div>
    </div>
  );
}
